module.exports = __webpack_public_path__ + "static/viber_stikeri-6cf1c4e7434a95a32db1a7b82fd31072.jpg";